import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

import { FooterLink, ModalButton } from '../styles/footer-item.style';
import gaEvent from '../../../utils/gaEvent';

const propTypes = {
  target: PropTypes.string,
  overlay: PropTypes.string,
  text: PropTypes.string,
};

const defaultProps = {
  target: '',
  overlay: '',
  text: '',
};

/**
 * Send a google analytics event and do a toggle
 * @param {string} destination Link destination
 */
const footerItemClick = (destination) => {
  gaEvent({
    eventCategory: 'Footer',
    eventAction: 'Click',
    eventLabel: destination,
  });
};

/**
 * Footer item
 * @param {object} props Incoming props
 * @returns {XML} Footer Item
 */
const FooterItem = (props) => {
  const {
    target, overlay, desktop, text, show, primary, deeplink, newWindow,
  } = props;
  const isExternal = target.indexOf('mailto:') > -1 || target.indexOf('http') > -1;
  if (target && isExternal) {
    return (
      <FooterLink>
        <a
          className={`footer__link ${overlay ? 'overlay-toggle' : ''} ${primary ? 'primary' : ''}`}
          href={target}
          aria-label={overlay ? `Open ${text}` : `${text} Footer Link`}
          data-target={overlay ? `${overlay}-overlay` : ''}
          rel="noopener noreferrer"
          onClick={() => footerItemClick(text)}
          target="blank"
        >
          {text}
        </a>
      </FooterLink>
    );
  }
  if (deeplink) {
    return (
      <FooterLink>
        <Link
          className={`footer__link ${overlay ? 'overlay-toggle' : ''} ${desktop ? 'desktop-only' : ''} ${
            primary ? 'primary' : ''
          }`}
          to={`${target}`}
          data-target={overlay ? `${overlay}-overlay` : ''}
          aria-label={overlay ? `Open ${text}` : `${text} Footer Link`}
          onClick={() => footerItemClick(text)}
          target={newWindow ? '_blank' : '_self'}
        >
          {text}
        </Link>
      </FooterLink>
    );
  }
  if (show) {
    return (
      <FooterLink>
        <ModalButton
          type="button"
          className={`footer__link ${overlay ? 'overlay-toggle' : ''} ${desktop ? 'desktop-only' : ''}`}
          data-target={overlay ? `${overlay}-overlay` : ''}
          aria-label={overlay ? `Open ${text}` : `${text} Footer Link`}
          onClick={() => {
            footerItemClick(text);
            show(overlay);
          }}
        >
          {text}
        </ModalButton>
      </FooterLink>
    );
  }
  return (
    <FooterLink>
      <Link
        className={`footer__link ${overlay ? 'overlay-toggle' : ''} ${desktop ? 'desktop-only' : ''} ${
          primary ? 'primary' : ''
        }`}
        to={`${target}`}
        data-target={overlay ? `${overlay}-overlay` : ''}
        aria-label={overlay ? `Open ${text}` : `${text} Footer Link`}
        onClick={() => {
          footerItemClick(text);
        }}
        target={newWindow ? '_blank' : '_self'}
      >
        {text}
      </Link>
    </FooterLink>
  );
};

FooterItem.propTypes = propTypes;
FooterItem.defaultProps = defaultProps;

export default FooterItem;



// WEBPACK FOOTER //
// ./src/components/footer/components/footer-item.js